import * as React from 'react';
import BumpButton from './bump_button';
import { CoreBumpRecommendationListingCard } from '../../schemas/rql';
import { BumpStats } from './bump_stats';
import { BumpExplainer } from './bump_explainer';

interface Props {
  bid: number;
  listing: CoreBumpRecommendationListingCard.Fragment;
  showModal: boolean;
  // props for BumpStats
  impressions: number;
  salesCount: number;
  salesSpent: string;
  salesRevenue: string;
}

export function ProductPageBumpV2(props: Props) {
  return (
    <div className="g-container d-flex fx-align-center mobile-d-block">
      <div className="g-col">
        {!props.bid && <BumpExplainer />}
        {!!props.bid && <BumpStats
          impressions={props.impressions}
          salesCount={props.salesCount}
          salesSpent={props.salesSpent}
          salesRevenue={props.salesRevenue}
          hasInventory={props.listing.hasInventory}
        />}
      </div>
      <div className="g-col align-center fx-grow mobile-mt-2">
        <BumpButton
          listingId={props.listing.id}
          showModal={props.showModal}
          bid={props.bid}
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/bump/product_page_bump_v2.tsx